import React, { useState, useEffect } from 'react';
import config from '../../config.json';
import axios from 'axios';
import { Col, Row, Spin } from 'antd';
import ErrorPage from '../error-views/errorPage'
import DataDisplayWidget from 'cl-library/dist/components/shared-components/DataDisplayWidget';
import { UserSwitchOutlined } from '@ant-design/icons';
import EveningTableData from './EveningTableData';
import MorningTableData from './MorningTableData';

const Home = () => {
  const [data, setData] = useState([]);
  const [morData, setmorData] = useState([]);
  const [eveData, seteveData] = useState([]);
  const [apiError, setapiError] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchData = async (url, setDataFunc) => {
      try {
        const response = await axios.get(url);
        if (response.data.status === "error") {
          setapiError(response.data);
        } else {
          setDataFunc(response.data);
        }
      } catch (err) {
        let obj = { "status": "error", "message": "Network Error" };
        if (err.response) {
          setapiError(err.response);
        } else {
          setapiError(obj);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData(config.pendingEnrolledAndDropout, setData);
    fetchData(config.pendingMorningResponse, setmorData);
    fetchData(config.pendingEveningResponse, seteveData);
  }, []);

  if (apiError) {
    return <ErrorPage details={apiError} />;
  }
  else if (loading) {
    return <Spin tip="Loading.."></Spin>;
  }
  else {
    return (
      <>
        <h1>Home</h1>
        <div style={{ backgroundColor: '#f0f0f0' }}>
          {data.length > 0 ?
            <>
              <Row gutter={16} style={{ margin: '10px', padding: '10px', paddingTop: '30px', paddingBottom: '5px' }}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                  <DataDisplayWidget
                    icon={<UserSwitchOutlined />}
                    value={data[0].count}
                    title="Pending Enrolled"
                    color="volcano"
                    size={"20"}
                    vertical={true}
                    avatarSize={50}
                    cardHeight={200}
                  />
                </Col>

                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>

                  <DataDisplayWidget
                    icon={<UserSwitchOutlined />}
                    value={data[1].count}
                    title="Pending DropOut"
                    color="volcano"
                    size={"20"}
                    vertical={true}
                    avatarSize={50}
                    cardHeight={200}
                  />
                </Col>
              </Row>
            </>
            :
            ""}

          <Row gutter={16} style={{ margin: '10px', padding: '10px', paddingTop: '1px', paddingBottom: '30px' }}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
              {morData.length > 0 ?
                <MorningTableData data={morData} />
                : ""
              }
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
              {eveData.length > 0 ?
                <EveningTableData data={eveData} />
                : ""
              }
            </Col>
          </Row>
        </div>
      </>
    );
  }


}
export default Home